import { Link } from 'react-router-dom';
import { Zap, MessageSquare, HelpCircle, Shield, FileText } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative z-10 px-4 py-6 border-t border-border bg-background">
      <div className="max-w-4xl mx-auto text-center space-y-3">
        <div className="flex items-center justify-center gap-2">
          <Zap className="w-4 h-4 text-primary" />
          <span className="font-semibold text-sm">FlipValue</span>
          <span className="text-sm text-muted-foreground">– Built for resellers, by resellers.</span>
        </div>
        
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link 
            to="/contact"
            className="inline-flex items-center gap-1.5 text-sm text-primary hover:underline"
          >
            <HelpCircle className="w-3.5 h-3.5" />
            Contact
          </Link>
          <span className="text-muted-foreground">•</span>
          <Link 
            to="/privacy"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
          >
            <Shield className="w-3.5 h-3.5" />
            Privacy
          </Link>
          <span className="text-muted-foreground">•</span>
          <Link 
            to="/terms"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
          >
            <FileText className="w-3.5 h-3.5" />
            Terms
          </Link>
        </div>
        
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} FlipValue. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
